import { useState, useEffect } from 'react';

export default function FloatingElements() {
  const [showSticky, setShowSticky] = useState(false);
  const [tooltip, setTooltip] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowSticky(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* WhatsApp Floating Button */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
        {tooltip && (
          <div className="bg-white text-[#2D2D2D] text-xs font-medium px-4 py-2 rounded-full shadow-lg whitespace-nowrap border border-[#FFE5EC] animate-fade-in">
            Mesaj Gönder 💬
          </div>
        )}
        <a
          href="https://wa.me/905412190629"
          target="_blank"
          rel="nofollow noreferrer"
          onMouseEnter={() => setTooltip(true)}
          onMouseLeave={() => setTooltip(false)}
          className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg hover:bg-[#1DA851] transition-all duration-300 hover:scale-110 relative"
          style={{ boxShadow: '0 4px 24px rgba(37, 211, 102, 0.4)' }}
        >
          <i className="ri-whatsapp-line text-2xl md:text-3xl"></i>
          {/* Pulse ring */}
          <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25 pointer-events-none"></span>
        </a>
      </div>

      {/* Sticky "Randevu Al" Bottom Bar - Mobile only */}
      <div
        className={`fixed bottom-0 left-0 right-0 z-40 md:hidden transition-all duration-300 ${
          showSticky ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
        }`}
        style={{ boxShadow: '0 -4px 20px rgba(0,0,0,0.08)' }}
      >
        <div className="bg-white/95 backdrop-blur-md border-t border-[#FFE5EC] px-4 py-3 flex items-center gap-3">
          <a
            href="#iletisim"
            className="flex-1 flex items-center justify-center gap-2 bg-[#D4AF37] text-white py-3 rounded-full text-sm font-semibold whitespace-nowrap"
          >
            <i className="ri-calendar-check-line"></i>
            RANDEVU AL
          </a>
          <a
            href="tel:02222347234"
            className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-[#D4AF37] text-[#D4AF37] flex-shrink-0"
          >
            <i className="ri-phone-line text-lg"></i>
          </a>
        </div>
      </div>

      {/* Desktop sticky "Randevu Al" top-right when scrolled */}
      {showSticky && (
        <div className="fixed top-20 right-0 z-40 hidden md:block">
          <a
            href="#iletisim"
            className="flex items-center gap-2 bg-[#D4AF37] text-white px-4 py-3 rounded-l-full text-xs font-semibold hover:bg-[#B8962E] transition-colors shadow-lg whitespace-nowrap"
            style={{ boxShadow: '-4px 4px 16px rgba(212,175,55,0.3)' }}
          >
            <i className="ri-calendar-check-line"></i>
            Randevu Al
          </a>
        </div>
      )}
    </>
  );
}
